import { render, staticRenderFns } from "./VDynamicModalGeneral.vue?vue&type=template&id=2f9ef553&"
import script from "./VDynamicModalGeneral.vue?vue&type=script&lang=ts&"
export * from "./VDynamicModalGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports